import { initElements } from '../define/shared';

export default function initHeader() {
    initElements('.siteHeaderDesktop', header => {
        let prevScrollPosition = window.scrollY;

        function handleScroll() {
            if (prevScrollPosition < window.scrollY && window.scrollY > 0) {
                header.classList.add('headerTopHidden');
            } else if (prevScrollPosition > window.scrollY) {
                header.classList.remove('headerTopHidden');
            }

            if (window.scrollY > 0) {
                header.classList.add('withBackground');
            } else {
                header.classList.remove('withBackground');
            }

            prevScrollPosition = window.scrollY;

            requestAnimationFrame(handleScroll);
        }

        handleScroll();
    });

    initElements('.siteHeaderMobile', header => {
        const menuToggles = [].slice.call(header.querySelectorAll('.mobileMenuToggle'));
        const submenuToggles = [].slice.call(header.querySelectorAll('.menu-item-has-children > .submenuToggle'));

        menuToggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                header.classList.toggle('is-active');
            });
        });

        submenuToggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                toggle.parentElement.classList.toggle('is-active');
            });
        });
    });
}
